module.exports = __webpack_public_path__ + "static/media/t-shirt-mask.c31101f3.png";